import { AspectRatio } from "../utils/styleHelpers"

export const ASPECT_RATIO: AspectRatio = {
  s: 0.92,
  m: 1.89,
  l: 0.9,
}
